import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/card';
import { isAppSupported } from '@/utils/device';
import BreezeLoginButton from './buttons/BreezeLoginButton';
import LoginFooter from './LoginFooter';
import BreezeEmailForm from './BreezeEmailForm';
import PhantomBrowser from './phantom/PhantomBrowser';
import PhantomDeepLink from './phantom/PhantomDeepLink';

function LoginButtons({
  setIsEmailForm,
}: {
  setIsEmailForm: Dispatch<SetStateAction<boolean>>;
}) {
  const [isSupportedDevice, setIsSupportedDevice] = useState(false);

  useEffect(() => {
    setIsSupportedDevice(isAppSupported());
  }, []);

  return (
    <>
      <div className="text-center">
        Phantom or Breeze wallet connections are required to train Map AI and
        earn HONEY
      </div>
      {isSupportedDevice ? <PhantomDeepLink /> : <PhantomBrowser />}
      <BreezeLoginButton onClick={() => setIsEmailForm(true)} />
    </>
  );
}

export default function LoginCard() {
  const [isEmailForm, setIsEmailForm] = useState(false);

  return (
    <Card className="flex w-full max-w-[378px] flex-col items-center p-6">
      <CardHeader className="p-0 pb-4">
        <CardTitle className="p-0 text-base font-bold leading-normal sm:text-xl">
          Connect Wallet
        </CardTitle>
      </CardHeader>
      <CardContent className="flex w-full p-0">
        <div
          data-visible={!isEmailForm}
          className="flex w-full flex-col items-center gap-4 data-[visible=false]:hidden">
          <LoginButtons setIsEmailForm={setIsEmailForm} />
        </div>
        <div
          data-visible={isEmailForm}
          className="flex w-full flex-col items-center gap-4 data-[visible=false]:hidden">
          <BreezeEmailForm
            redirectionPath="connect-wallet"
            setIsEmailForm={setIsEmailForm}
          />
        </div>
      </CardContent>
      <CardFooter className="p-0 pt-4">
        <LoginFooter />
      </CardFooter>
    </Card>
  );
}
